// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Level_level__SIp8h {
width: 100%;
/* max-width: 400px; */
padding-left: 10px;
padding-right: 10px;
color: #848484;

}


.Level_container__9jAvM {
display: flex;
height: 45px;

align-items: center;
justify-content: space-between;
}

.Level_left__7M0wA {
display: flex;
gap:10px;
align-items: center;
font-weight: bold;
}

.Level_wolficon__4v5Lm {
    width: 30px;
    height: 30px;
}

.Level_i__e8-9t {
    width: 20px; 
    background-color: white;
    border-radius: 50%;
}

.Level_flag__HbYmR {
    width: 20px;
    height: 20px;
}

.Level_flagBtn__vNtb9 {
    color:white;
    font-weight: 400;
    display:flex;
    gap:3px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Level/Level.module.css"],"names":[],"mappings":"AAAA;AACA,WAAW;AACX,sBAAsB;AACtB,kBAAkB;AAClB,mBAAmB;AACnB,cAAc;;AAEd;;;AAGA;AACA,aAAa;AACb,YAAY;;AAEZ,mBAAmB;AACnB,8BAA8B;AAC9B;;AAEA;AACA,aAAa;AACb,QAAQ;AACR,mBAAmB;AACnB,iBAAiB;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,OAAO;AACX","sourcesContent":[".level {\nwidth: 100%;\n/* max-width: 400px; */\npadding-left: 10px;\npadding-right: 10px;\ncolor: #848484;\n\n}\n\n\n.container {\ndisplay: flex;\nheight: 45px;\n\nalign-items: center;\njustify-content: space-between;\n}\n\n.left {\ndisplay: flex;\ngap:10px;\nalign-items: center;\nfont-weight: bold;\n}\n\n.wolficon {\n    width: 30px;\n    height: 30px;\n}\n\n.i {\n    width: 20px; \n    background-color: white;\n    border-radius: 50%;\n}\n\n.flag {\n    width: 20px;\n    height: 20px;\n}\n\n.flagBtn {\n    color:white;\n    font-weight: 400;\n    display:flex;\n    gap:3px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"level": `Level_level__SIp8h`,
	"container": `Level_container__9jAvM`,
	"left": `Level_left__7M0wA`,
	"wolficon": `Level_wolficon__4v5Lm`,
	"i": `Level_i__e8-9t`,
	"flag": `Level_flag__HbYmR`,
	"flagBtn": `Level_flagBtn__vNtb9`
};
export default ___CSS_LOADER_EXPORT___;
